/**
 * Функция на основе настроек слоя от сервера создает настройки слоя для хранения во vuex
 * все добавления в objectLayerSettings пропускать через эту функцию
 * Это сделано чтобы информация на сервере не хранила системных вещей, которые нужны только на клиенте
 * также можно не писать на сервере все настройки, эта функция задаст значения по умолчанию
 * @param {*} layerSettingsFromServer
 * @returns
 */
export function layerSettingsFactory(layerSettingsFromServer) {
  return {
    /**Идентификатор */
    id: layerSettingsFromServer.id,

    /**Идентификатор родительского слоя */
    parentId: layerSettingsFromServer.parentId || null,

    /**Флаг группового слоя */
    groupLayer: layerSettingsFromServer.groupLayer || false,

    /**Тип слоя */
    type: layerSettingsFromServer.type || null,

    /**Идентификатор стиля слоя */
    styleId: layerSettingsFromServer.styleId || null,

    /**Название */
    name: layerSettingsFromServer.name || '',

    /**Порядковый номер */
    order: layerSettingsFromServer.order || -1000,

    /**Видимость слоя */
    visibility: layerSettingsFromServer.visibility || false, // видимость в основном окне объектов

    /**Видимость слоя в режиме редактирования зон */
    zoneVisibility: layerSettingsFromServer.zoneVisibility || false,

    /**Разрешена видимость только одного дочернего слоя */
    singleChildVisibility: layerSettingsFromServer.singleChildVisibility || false,

    /**Раскрыт ли слой */
    open: layerSettingsFromServer.open || false,

    /**Можно ли выбрать слой по клику (по умолчанию папку нельзя, но, например, зоны и адреса кп - исключения) */
    selectable: layerSettingsFromServer.selectable || false,

    /**Изменение видимости объектов слоя */
    canToggleItemsVisibility: layerSettingsFromServer.canToggleItemsVisibility || false,

    /**Подгрузка дополнительных объектов при скролле */
    scrollable: layerSettingsFromServer.scrollable || false,

    /**Скрыть слой полностью, нужно чтобы скрывать слои для отладки, но не удалять при этом настройки */
    hide: layerSettingsFromServer.hide || false,

    /**Скрыть из левой панели */
    hideFromLeftPanel: layerSettingsFromServer.hideFromLeftPanel || false,

    /**Показать или скрыть названия на карте (пока только в территориальном делении) */
    showLabels: layerSettingsFromServer.showLabels || false,

    /**Минимальный зум на котором отображаются подписи */
    labelsMinZoom: layerSettingsFromServer.labelsMinZoom || null,

    /**Список полей, которые нужны от бека при скролле в левой панели */
    fields: layerSettingsFromServer.fields || 'id,name,address',

    /**Скрыть зоны ро для публичных ws (использовалось на хмао) */
    hidePublicTransport: layerSettingsFromServer.hidePublicTransport || false,

    /**Css-класс иконки для отображения в панели слоев */
    iconClass: layerSettingsFromServer.iconClass || false,

    /**Иконка для отображения в панели слоев*/
    icon: layerSettingsFromServer.icon ? { ...layerSettingsFromServer.icon } : null,

    /**Показать количество дочерних слоев */
    showChildLayerCount: layerSettingsFromServer.showChildLayerCount || false,

    /**Показать количество объектов в дочерних слоях */
    showChildLayerObjectsCount: layerSettingsFromServer.showChildLayerObjectsCount || false,

    /**Возможность перетаскивания дочерних слоев */
    childrenDraggable: layerSettingsFromServer.childrenDraggable === false ? false : true,

    /**Возможность добавления объектов в слой (кнопка "+"). TODO: возможно надо будет учесть права пользователя */
    canAdd: layerSettingsFromServer.canAdd || false,
    /**Название мутации при нажатии "+" TODO: продумать как адекватно настраивать? Не универсально */
    addMutation: layerSettingsFromServer.addMutation || null,
    /**Параметры мутации добавления */
    addMutationPayload: layerSettingsFromServer.addMutationPayload || null,

    //Сохраним в этот блок настройки по умолчанию, чтобы иметь возможность к ним вернуться
    defaultSettings: {
      visibility: layerSettingsFromServer.visibility || false,
      zoneVisibility: layerSettingsFromServer.zoneVisibility || false
    },

    /**Источник данных слоя */
    dataSource: layerSettingsFromServer.dataSource || null,

    /**Уровень административного деления */
    admLevel: layerSettingsFromServer.admLevel || null,

    /**Уровень административного деления по умолчанию для папки для группы зон по умолчанию */
    defaultAdmLevel: layerSettingsFromServer.defaultAdmLevel || null,

    /**
     * Название компонента vue
     * который надо использовать для отображения объекта слоя в левой панели
     * сейчас актуально для контейнерных площадок
     * Если ничего не указать или указать неверно то используется стандартный LayersItem
     */
    layerItemComponent: layerSettingsFromServer.layerItemComponent || null,

    /**При клике на линию чувствительность в пикселях */
    tolerance: layerSettingsFromServer.tolerance || 0,

    /**Выбранная цветовая раскраска*/
    selectedColor: layerSettingsFromServer.selectedColor || 'default',

    /**Доступные цветовые раскраски*/
    coloringType: layerSettingsFromServer.coloringType,

    /**Всегда отображать слой в панели слева */
    alwaysShowInPanel: layerSettingsFromServer.alwaysShowInPanel || false,

    /**Отображение кнопки настройки маршрутов */
    carTypesButton: layerSettingsFromServer.carTypesButton || false,

    /**Отображение кнопки вида транспорта */
    transportTypeButton: layerSettingsFromServer.transportTypeButton || false,

    /**Скрыть изменяющиеся атрибуты нижней панели */
    hideChangingAttributes: layerSettingsFromServer.hideChangingAttributes || false,

    /**Фильтровать содержимое на клиенте с помощью строки "Быстрый поиск" */
    filterByText: layerSettingsFromServer.filterByText || false,

    //Специальная настройка для ОИ, открывает все кластеры
    openAllClusters: layerSettingsFromServer.openAllClusters || false,
    toggleAllClustersButton: layerSettingsFromServer.toggleAllClustersButton || false,

    detailInfoType: layerSettingsFromServer.detailInfoType || null,
    selectedStyleId: layerSettingsFromServer.selectedStyleId || null,
    tooltipTemplate: layerSettingsFromServer.tooltipTemplate || null,
    multipleTooltipTemplate: layerSettingsFromServer.multipleTooltipTemplate || null,
    tooltipSettings: layerSettingsFromServer.tooltipSettings || null,

    /**Скрыть Вход и Выход из подсказки при наведении на ОИ */
    hideTreatmentsInPopup: layerSettingsFromServer.hideTreatmentsInPopup || false,

    loading: false,
    layerLoadEntity: layerSettingsFromServer.layerLoadEntity || null,

    /**Текст подсказок и подписей*/
    labels: {
      collapseButton: 'Закрыть список объектов слоя',
      expandButton: 'Открыть список объектов слоя',
      addButton: 'Добавить объект',
      dragHandler: 'Изменить порядок слоев',
      coloringButton: 'Для изменения настроек отображения нажмите на кнопку',
      carTypeButton: 'Настройка типов автомобилей',
      hideButton: 'Скрыть',
      showButton: 'Отобразить',
      showMapLabels: 'Отобразить подписи на карте',
      hideMapLabels: 'Скрыть подписи на карте',
      itemHint: 'Выбрать объект',
      ...(layerSettingsFromServer.labels || {})
    }
  }
}

export function infoLayerSettingsFactory(layerSettingsFromServer) {
  return {
    ...layerSettingsFactory(layerSettingsFromServer),

    //Идентификатор иконки для обозначения на карте
    mapIconId: layerSettingsFromServer.mapIconId || null,

    /**Цвет, синий по умолчанию */
    color: layerSettingsFromServer.color || '#0000FF',

    /**Настройки атрибутов слоя */
    headers: layerSettingsFromServer.headers || [],

    /**Надо запомнить id от сервера для инфослоя, чтобы потом нормально данные запросить */
    serverId: layerSettingsFromServer.serverId || null,

    /**Специальный флаг, чтобы отличить инфослой от остальных и не парсить идентификатор на предмет наличия "info" */
    isInfoLayer: layerSettingsFromServer.isInfoLayer || false,

    /**Наличие маршрутов для линейного инфослоя */
    isTrip: layerSettingsFromServer.is_trip || false
  }
}

export function flowLayerSettingsFactory(layerSettingsFromServer) {
  return {
    ...layerSettingsFactory(layerSettingsFromServer),

    /** показать только потоки, у которых есть выбранные проблемы */
    selectedProblems: layerSettingsFromServer.selectedProblems || null,

    /** Выбранные типы транспорта (нужно для ОПВК) */
    selectedTransportTypes: layerSettingsFromServer.selectedTransportTypes || null,

    /**Уровень потоков (массив, например [1, 2]) */
    selectedLevel: layerSettingsFromServer.selectedLevel || null,

    /**Выбранная территория для отображения потоков только этой территории */
    selectedTerritory: layerSettingsFromServer.selectedTerritory || null,

    /**Показывать предметы на потоке */
    showItems: layerSettingsFromServer.showItems || false,

    /**Анимировать потоки */
    animation: layerSettingsFromServer.animation || false,

    /**Скрыть предметы в подсказке потока */
    hideItemsInPopup: layerSettingsFromServer.hideItemsInPopup || false,

    /**Скрыть проблемы в подсказке потока */
    hideProblemsInPopup: layerSettingsFromServer.hideProblemsInPopup || false
  }
}

export function zonegroupLayerSettingsFactory(layerSettingsFromServer) {
  return {
    ...layerSettingsFactory(layerSettingsFromServer),

    /**Тип раскраски - группа зон */
    coloringType: 'zonegroup',

    /**Признак ГЗ по умолчанию содержит территориальное деление*/
    default: layerSettingsFromServer.default,

    /**Чистое Id группы зон*/
    serverId: layerSettingsFromServer.serverId,

    /**Признак группы зон оператора (транспортная)*/
    operator_zone: layerSettingsFromServer.operator_zone,

    /**Специальный флаг, чтобы при обходе дерева понять что это группа зон */
    isZoneGroup: true
  }
}

export function admLevelLayerSettingsFactory(layerSettingsFromServer) {
  return {
    ...layerSettingsFactory(layerSettingsFromServer),

    /**Скрыть предыдущие слои на этом уровне */
    hidePrevSiblings: true,

    /**Показать предыдущие слои на этом уровне */
    showNextSiblings: true
  }
}

export function zoneLayerSettingsFactory(layerSettingsFromServer) {
  return {
    ...layerSettingsFactory(layerSettingsFromServer),

    /**Идентификатор цвета для раскраски объектов слоя по умолчанию */
    colorId: layerSettingsFromServer.colorId || null,

    /**Надо запомнить id от сервера для зоны, чтобы потом нормально данные о ней запросить */
    serverId: layerSettingsFromServer.serverId || null
  }
}

export function vectorTileLayerSettingsFacroty(layerSettingsFromServer) {
  return {
    ...layerSettingsFactory(layerSettingsFromServer),

    /**
     * Ссылка на сервис векторных плиток
     */
    url: layerSettingsFromServer.url || '',

    /**
     * Глобальные фильтрационные параметры которые есть в mw
     * treatment_type
     */
    mwParams: layerSettingsFromServer.mwParams || null,

    /**Дополнительные параметры строки запроса */
    urlParams: layerSettingsFromServer.urlParams || {}
  }
}

export const layerSettingsFactories = {
  flow: flowLayerSettingsFactory,
  info: infoLayerSettingsFactory,
  admLevel: admLevelLayerSettingsFactory,
  zonegroup: zonegroupLayerSettingsFactory,
  zone: zoneLayerSettingsFactory,
  default: layerSettingsFactory,
  vectorTile: vectorTileLayerSettingsFacroty
}



// WEBPACK FOOTER //
// ./src/store/objects/layerSettingsFactory.js